module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/File-done-01823eebcd133434e419160c2800c8a3.svg";